"use client"; // src/navigation-menu.tsx

import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeNavigationMenu", "value", "onValueChange", "defaultValue", "delayDuration", "skipDelayDuration", "orientation", "dir"],
    _excluded2 = ["__scopeNavigationMenu", "value", "onValueChange", "defaultValue", "orientation"],
    _excluded3 = ["__scopeNavigationMenu"],
    _excluded4 = ["__scopeNavigationMenu", "value"],
    _excluded5 = ["__scopeNavigationMenu", "disabled"],
    _excluded6 = ["__scopeNavigationMenu", "active", "onSelect"],
    _excluded7 = ["forceMount"],
    _excluded8 = ["__scopeNavigationMenu"],
    _excluded9 = ["forceMount"],
    _excluded10 = ["__scopeNavigationMenu", "value", "triggerRef", "focusProxyRef", "wasEscapeCloseRef", "onRootContentClose", "onContentFocusOutside"],
    _excluded11 = ["forceMount"],
    _excluded12 = ["__scopeNavigationMenu", "children"],
    _excluded13 = ["ref", "forceMount"],
    _excluded14 = ["__scopeNavigationMenu"],
    _excluded15 = ["__scopeNavigationMenu"];
import * as React from "react";
import ReactDOM from "react-dom";
import { createContextScope } from "@radix-ui/react-context";
import { composeEventHandlers } from "@radix-ui/primitive";
import { Primitive, dispatchDiscreteCustomEvent } from "@radix-ui/react-primitive";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { composeRefs, useComposedRefs } from "@radix-ui/react-compose-refs";
import { useDirection } from "@radix-ui/react-direction";
import { Presence } from "@radix-ui/react-presence";
import { useId } from "@radix-ui/react-id";
import { createCollection } from "@radix-ui/react-collection";
import { DismissableLayer } from "@radix-ui/react-dismissable-layer";
import { usePrevious } from "@radix-ui/react-use-previous";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var NAVIGATION_MENU_NAME = "NavigationMenu";

var _createCollection = createCollection(NAVIGATION_MENU_NAME),
    _createCollection2 = _slicedToArray(_createCollection, 3),
    Collection = _createCollection2[0],
    useCollection = _createCollection2[1],
    createCollectionScope = _createCollection2[2];

var _createCollection3 = createCollection(NAVIGATION_MENU_NAME),
    _createCollection4 = _slicedToArray(_createCollection3, 3),
    FocusGroupCollection = _createCollection4[0],
    useFocusGroupCollection = _createCollection4[1],
    createFocusGroupCollectionScope = _createCollection4[2];

var _createContextScope = createContextScope(NAVIGATION_MENU_NAME, [createCollectionScope, createFocusGroupCollectionScope]),
    _createContextScope2 = _slicedToArray(_createContextScope, 2),
    createNavigationMenuContext = _createContextScope2[0],
    createNavigationMenuScope = _createContextScope2[1];

var _createNavigationMenu = createNavigationMenuContext(NAVIGATION_MENU_NAME),
    _createNavigationMenu2 = _slicedToArray(_createNavigationMenu, 2),
    NavigationMenuProviderImpl = _createNavigationMenu2[0],
    useNavigationMenuContext = _createNavigationMenu2[1];

var _createNavigationMenu3 = createNavigationMenuContext(NAVIGATION_MENU_NAME),
    _createNavigationMenu4 = _slicedToArray(_createNavigationMenu3, 2),
    ViewportContentProvider = _createNavigationMenu4[0],
    useViewportContentContext = _createNavigationMenu4[1];

var NavigationMenu = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      valueProp = props.value,
      onValueChange = props.onValueChange,
      defaultValue = props.defaultValue,
      _props$delayDuration = props.delayDuration,
      delayDuration = _props$delayDuration === void 0 ? 200 : _props$delayDuration,
      _props$skipDelayDurat = props.skipDelayDuration,
      skipDelayDuration = _props$skipDelayDurat === void 0 ? 300 : _props$skipDelayDurat,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
      dir = props.dir,
      NavigationMenuProps = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      navigationMenu = _React$useState2[0],
      setNavigationMenu = _React$useState2[1];

  var composedRef = useComposedRefs(forwardedRef, function (node) {
    return setNavigationMenu(node);
  });
  var direction = useDirection(dir);
  var openTimerRef = React.useRef(0);
  var closeTimerRef = React.useRef(0);
  var skipDelayTimerRef = React.useRef(0);

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isOpenDelayed = _React$useState4[0],
      setIsOpenDelayed = _React$useState4[1];

  var _useControllableState = useControllableState({
    prop: valueProp,
    onChange: function onChange(value2) {
      var isOpen = value2 !== "";
      var hasSkipDelayDuration = skipDelayDuration > 0;

      if (isOpen) {
        window.clearTimeout(skipDelayTimerRef.current);
        if (hasSkipDelayDuration) setIsOpenDelayed(false);
      } else {
        window.clearTimeout(skipDelayTimerRef.current);
        skipDelayTimerRef.current = window.setTimeout(function () {
          return setIsOpenDelayed(true);
        }, skipDelayDuration);
      }

      onValueChange === null || onValueChange === void 0 || onValueChange(value2);
    },
    defaultProp: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
    caller: NAVIGATION_MENU_NAME
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      value = _useControllableState2[0],
      setValue = _useControllableState2[1];

  var startCloseTimer = React.useCallback(function () {
    window.clearTimeout(closeTimerRef.current);
    closeTimerRef.current = window.setTimeout(function () {
      return setValue("");
    }, 150);
  }, [setValue]);
  var handleOpen = React.useCallback(function (itemValue) {
    window.clearTimeout(closeTimerRef.current);
    setValue(itemValue);
  }, [setValue]);
  var handleDelayedOpen = React.useCallback(function (itemValue) {
    var isOpenItem = value === itemValue;

    if (isOpenItem) {
      window.clearTimeout(closeTimerRef.current);
    } else {
      openTimerRef.current = window.setTimeout(function () {
        window.clearTimeout(closeTimerRef.current);
        setValue(itemValue);
      }, delayDuration);
    }
  }, [value, setValue, delayDuration]);
  React.useEffect(function () {
    return function () {
      window.clearTimeout(openTimerRef.current);
      window.clearTimeout(closeTimerRef.current);
      window.clearTimeout(skipDelayTimerRef.current);
    };
  }, []);
  return /* @__PURE__ */jsx(NavigationMenuProvider, {
    scope: __scopeNavigationMenu,
    isRootMenu: true,
    value: value,
    dir: direction,
    orientation: orientation,
    rootNavigationMenu: navigationMenu,
    onTriggerEnter: function onTriggerEnter(itemValue) {
      window.clearTimeout(openTimerRef.current);
      if (isOpenDelayed) handleDelayedOpen(itemValue);else handleOpen(itemValue);
    },
    onTriggerLeave: function onTriggerLeave() {
      window.clearTimeout(openTimerRef.current);
      startCloseTimer();
    },
    onContentEnter: function onContentEnter() {
      return window.clearTimeout(closeTimerRef.current);
    },
    onContentLeave: startCloseTimer,
    onItemSelect: function onItemSelect(itemValue) {
      setValue(function (prevValue) {
        return prevValue === itemValue ? "" : itemValue;
      });
    },
    onItemDismiss: function onItemDismiss() {
      return setValue("");
    },
    children: /* @__PURE__ */jsx(Primitive.nav, _objectSpread(_objectSpread({
      "aria-label": "Main",
      "data-orientation": orientation,
      dir: direction
    }, NavigationMenuProps), {}, {
      ref: composedRef
    }))
  });
});
NavigationMenu.displayName = NAVIGATION_MENU_NAME;
var SUB_NAME = "NavigationMenuSub";
var NavigationMenuSub = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      valueProp = props.value,
      onValueChange = props.onValueChange,
      defaultValue = props.defaultValue,
      _props$orientation2 = props.orientation,
      orientation = _props$orientation2 === void 0 ? "horizontal" : _props$orientation2,
      subProps = _objectWithoutProperties(props, _excluded2);

  var context = useNavigationMenuContext(SUB_NAME, __scopeNavigationMenu);

  var _useControllableState3 = useControllableState({
    prop: valueProp,
    onChange: onValueChange,
    defaultProp: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
    caller: SUB_NAME
  }),
      _useControllableState4 = _slicedToArray(_useControllableState3, 2),
      value = _useControllableState4[0],
      setValue = _useControllableState4[1];

  return /* @__PURE__ */jsx(NavigationMenuProvider, {
    scope: __scopeNavigationMenu,
    isRootMenu: false,
    value: value,
    dir: context.dir,
    orientation: orientation,
    rootNavigationMenu: context.rootNavigationMenu,
    onTriggerEnter: function onTriggerEnter(itemValue) {
      return setValue(itemValue);
    },
    onItemSelect: function onItemSelect(itemValue) {
      return setValue(itemValue);
    },
    onItemDismiss: function onItemDismiss() {
      return setValue("");
    },
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      "data-orientation": orientation
    }, subProps), {}, {
      ref: forwardedRef
    }))
  });
});
NavigationMenuSub.displayName = SUB_NAME;

var NavigationMenuProvider = function NavigationMenuProvider(props) {
  var scope = props.scope,
      isRootMenu = props.isRootMenu,
      rootNavigationMenu = props.rootNavigationMenu,
      dir = props.dir,
      orientation = props.orientation,
      children = props.children,
      value = props.value,
      onItemSelect = props.onItemSelect,
      onItemDismiss = props.onItemDismiss,
      onTriggerEnter = props.onTriggerEnter,
      onTriggerLeave = props.onTriggerLeave,
      onContentEnter = props.onContentEnter,
      onContentLeave = props.onContentLeave;

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      viewport = _React$useState6[0],
      setViewport = _React$useState6[1];

  var _React$useState7 = React.useState( /* @__PURE__ */new Map()),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      viewportContent = _React$useState8[0],
      setViewportContent = _React$useState8[1];

  var _React$useState9 = React.useState(null),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      indicatorTrack = _React$useState10[0],
      setIndicatorTrack = _React$useState10[1];

  return /* @__PURE__ */jsx(NavigationMenuProviderImpl, {
    scope: scope,
    isRootMenu: isRootMenu,
    rootNavigationMenu: rootNavigationMenu,
    value: value,
    previousValue: usePrevious(value),
    baseId: useId(),
    dir: dir,
    orientation: orientation,
    viewport: viewport,
    onViewportChange: setViewport,
    indicatorTrack: indicatorTrack,
    onIndicatorTrackChange: setIndicatorTrack,
    onTriggerEnter: useCallbackRef(onTriggerEnter),
    onTriggerLeave: useCallbackRef(onTriggerLeave),
    onContentEnter: useCallbackRef(onContentEnter),
    onContentLeave: useCallbackRef(onContentLeave),
    onItemSelect: useCallbackRef(onItemSelect),
    onItemDismiss: useCallbackRef(onItemDismiss),
    onViewportContentChange: React.useCallback(function (contentValue, contentData) {
      setViewportContent(function (prevContent) {
        prevContent.set(contentValue, contentData);
        return new Map(prevContent);
      });
    }, []),
    onViewportContentRemove: React.useCallback(function (contentValue) {
      setViewportContent(function (prevContent) {
        if (!prevContent.has(contentValue)) return prevContent;
        prevContent.delete(contentValue);
        return new Map(prevContent);
      });
    }, []),
    children: /* @__PURE__ */jsx(Collection.Provider, {
      scope: scope,
      children: /* @__PURE__ */jsx(ViewportContentProvider, {
        scope: scope,
        items: viewportContent,
        children: children
      })
    })
  });
};

var LIST_NAME = "NavigationMenuList";
var NavigationMenuList = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      listProps = _objectWithoutProperties(props, _excluded3);

  var context = useNavigationMenuContext(LIST_NAME, __scopeNavigationMenu);
  var list = /* @__PURE__ */jsx(Primitive.ul, _objectSpread(_objectSpread({
    "data-orientation": context.orientation
  }, listProps), {}, {
    ref: forwardedRef
  }));
  return /* @__PURE__ */jsx(Primitive.div, {
    style: {
      position: "relative"
    },
    ref: context.onIndicatorTrackChange,
    children: /* @__PURE__ */jsx(Collection.Slot, {
      scope: __scopeNavigationMenu,
      children: context.isRootMenu ? /* @__PURE__ */jsx(FocusGroup, {
        asChild: true,
        children: list
      }) : list
    })
  });
});
NavigationMenuList.displayName = LIST_NAME;
var ITEM_NAME = "NavigationMenuItem";

var _createNavigationMenu5 = createNavigationMenuContext(ITEM_NAME),
    _createNavigationMenu6 = _slicedToArray(_createNavigationMenu5, 2),
    NavigationMenuItemContextProvider = _createNavigationMenu6[0],
    useNavigationMenuItemContext = _createNavigationMenu6[1];

var NavigationMenuItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      valueProp = props.value,
      itemProps = _objectWithoutProperties(props, _excluded4);

  var autoValue = useId();
  var value = valueProp || autoValue || "LEGACY_REACT_AUTO_VALUE";
  var contentRef = React.useRef(null);
  var triggerRef = React.useRef(null);
  var focusProxyRef = React.useRef(null);
  var restoreContentTabOrderRef = React.useRef(function () {});
  var wasEscapeCloseRef = React.useRef(false);
  var handleContentEntry = React.useCallback(function () {
    var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "start";

    if (contentRef.current) {
      restoreContentTabOrderRef.current();
      var candidates = getTabbableCandidates(contentRef.current);
      if (candidates.length) focusFirst(side === "start" ? candidates : candidates.reverse());
    }
  }, []);
  var handleContentExit = React.useCallback(function () {
    if (contentRef.current) {
      var candidates = getTabbableCandidates(contentRef.current);
      if (candidates.length) restoreContentTabOrderRef.current = removeFromTabOrder(candidates);
    }
  }, []);
  return /* @__PURE__ */jsx(NavigationMenuItemContextProvider, {
    scope: __scopeNavigationMenu,
    value: value,
    triggerRef: triggerRef,
    contentRef: contentRef,
    focusProxyRef: focusProxyRef,
    wasEscapeCloseRef: wasEscapeCloseRef,
    onEntryKeyDown: handleContentEntry,
    onFocusProxyEnter: handleContentEntry,
    onRootContentClose: handleContentExit,
    onContentFocusOutside: handleContentExit,
    children: /* @__PURE__ */jsx(Primitive.li, _objectSpread(_objectSpread({}, itemProps), {}, {
      ref: forwardedRef
    }))
  });
});
NavigationMenuItem.displayName = ITEM_NAME;
var TRIGGER_NAME = "NavigationMenuTrigger";
var NavigationMenuTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      disabled = props.disabled,
      triggerProps = _objectWithoutProperties(props, _excluded5);

  var context = useNavigationMenuContext(TRIGGER_NAME, props.__scopeNavigationMenu);
  var itemContext = useNavigationMenuItemContext(TRIGGER_NAME, props.__scopeNavigationMenu);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(ref, itemContext.triggerRef, forwardedRef);
  var triggerId = makeTriggerId(context.baseId, itemContext.value);
  var contentId = makeContentId(context.baseId, itemContext.value);
  var hasPointerMoveOpenedRef = React.useRef(false);
  var wasClickCloseRef = React.useRef(false);
  var open = itemContext.value === context.value;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(Collection.ItemSlot, {
      scope: __scopeNavigationMenu,
      value: itemContext.value,
      children: /* @__PURE__ */jsx(FocusGroupItem, {
        asChild: true,
        children: /* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
          id: triggerId,
          disabled: disabled,
          "data-disabled": disabled ? "" : void 0,
          "data-state": getOpenState(open),
          "aria-expanded": open,
          "aria-controls": contentId
        }, triggerProps), {}, {
          ref: composedRefs,
          onPointerEnter: composeEventHandlers(props.onPointerEnter, function () {
            wasClickCloseRef.current = false;
            itemContext.wasEscapeCloseRef.current = false;
          }),
          onPointerMove: composeEventHandlers(props.onPointerMove, whenMouse(function () {
            if (disabled || wasClickCloseRef.current || itemContext.wasEscapeCloseRef.current || hasPointerMoveOpenedRef.current) return;
            context.onTriggerEnter(itemContext.value);
            hasPointerMoveOpenedRef.current = true;
          })),
          onPointerLeave: composeEventHandlers(props.onPointerLeave, whenMouse(function () {
            if (disabled) return;
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
          })),
          onClick: composeEventHandlers(props.onClick, function () {
            context.onItemSelect(itemContext.value);
            wasClickCloseRef.current = open;
          }),
          onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
            var verticalEntryKey = context.dir === "rtl" ? "ArrowLeft" : "ArrowRight";
            var entryKey = {
              horizontal: "ArrowDown",
              vertical: verticalEntryKey
            }[context.orientation];

            if (open && event.key === entryKey) {
              itemContext.onEntryKeyDown();
              event.preventDefault();
            }
          })
        }))
      })
    }), open && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx(VisuallyHiddenPrimitive.Root, {
        "aria-hidden": true,
        tabIndex: 0,
        ref: itemContext.focusProxyRef,
        onFocus: function onFocus(event) {
          var content = itemContext.contentRef.current;
          var prevFocusedElement = event.relatedTarget;
          var wasTriggerFocused = prevFocusedElement === ref.current;
          var wasFocusFromContent = content === null || content === void 0 ? void 0 : content.contains(prevFocusedElement);

          if (wasTriggerFocused || !wasFocusFromContent) {
            itemContext.onFocusProxyEnter(wasTriggerFocused ? "start" : "end");
          }
        }
      }), context.viewport && /* @__PURE__ */jsx("span", {
        "aria-owns": contentId
      })]
    })]
  });
});
NavigationMenuTrigger.displayName = TRIGGER_NAME;
var LINK_NAME = "NavigationMenuLink";
var LINK_SELECT = "navigationMenu.linkSelect";
var NavigationMenuLink = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      active = props.active,
      onSelect = props.onSelect,
      linkProps = _objectWithoutProperties(props, _excluded6);

  return /* @__PURE__ */jsx(FocusGroupItem, {
    asChild: true,
    children: /* @__PURE__ */jsx(Primitive.a, _objectSpread(_objectSpread({
      "data-active": active ? "" : void 0,
      "aria-current": active ? "page" : void 0
    }, linkProps), {}, {
      ref: forwardedRef,
      onClick: composeEventHandlers(props.onClick, function (event) {
        var target = event.target;
        var linkSelectEvent = new CustomEvent(LINK_SELECT, {
          bubbles: true,
          cancelable: true
        });
        target.addEventListener(LINK_SELECT, function (event2) {
          return onSelect === null || onSelect === void 0 ? void 0 : onSelect(event2);
        }, {
          once: true
        });
        dispatchDiscreteCustomEvent(target, linkSelectEvent);

        if (!linkSelectEvent.defaultPrevented && !event.metaKey) {
          var rootContentDismissEvent = new CustomEvent(ROOT_CONTENT_DISMISS, {
            bubbles: true,
            cancelable: true
          });
          dispatchDiscreteCustomEvent(target, rootContentDismissEvent);
        }
      }, {
        checkForDefaultPrevented: false
      })
    }))
  });
});
NavigationMenuLink.displayName = LINK_NAME;
var INDICATOR_NAME = "NavigationMenuIndicator";
var NavigationMenuIndicator = React.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
      indicatorProps = _objectWithoutProperties(props, _excluded7);

  var context = useNavigationMenuContext(INDICATOR_NAME, props.__scopeNavigationMenu);
  var isVisible = Boolean(context.value);
  return context.indicatorTrack ? ReactDOM.createPortal( /* @__PURE__ */jsx(Presence, {
    present: forceMount || isVisible,
    children: /* @__PURE__ */jsx(NavigationMenuIndicatorImpl, _objectSpread(_objectSpread({}, indicatorProps), {}, {
      ref: forwardedRef
    }))
  }), context.indicatorTrack) : null;
});
NavigationMenuIndicator.displayName = INDICATOR_NAME;
var NavigationMenuIndicatorImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      indicatorProps = _objectWithoutProperties(props, _excluded8);

  var context = useNavigationMenuContext(INDICATOR_NAME, __scopeNavigationMenu);
  var getItems = useCollection(__scopeNavigationMenu);

  var _React$useState11 = React.useState(null),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      activeTrigger = _React$useState12[0],
      setActiveTrigger = _React$useState12[1];

  var _React$useState13 = React.useState(null),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      position = _React$useState14[0],
      setPosition = _React$useState14[1];

  var isHorizontal = context.orientation === "horizontal";
  var isVisible = Boolean(context.value);
  React.useEffect(function () {
    var _items$find;

    var items = getItems();
    var triggerNode = (_items$find = items.find(function (item) {
      return item.value === context.value;
    })) === null || _items$find === void 0 ? void 0 : _items$find.ref.current;
    if (triggerNode) setActiveTrigger(triggerNode);
  }, [getItems, context.value]);

  var handlePositionChange = function handlePositionChange() {
    if (activeTrigger) {
      setPosition({
        size: isHorizontal ? activeTrigger.offsetWidth : activeTrigger.offsetHeight,
        offset: isHorizontal ? activeTrigger.offsetLeft : activeTrigger.offsetTop
      });
    }
  };

  useResizeObserver(activeTrigger, handlePositionChange);
  useResizeObserver(context.indicatorTrack, handlePositionChange);
  return position ? /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    "aria-hidden": true,
    "data-state": isVisible ? "visible" : "hidden",
    "data-orientation": context.orientation
  }, indicatorProps), {}, {
    ref: forwardedRef,
    style: _objectSpread(_objectSpread({
      position: "absolute"
    }, isHorizontal ? {
      left: 0,
      width: position.size + "px",
      transform: "translateX(".concat(position.offset, "px)")
    } : {
      top: 0,
      height: position.size + "px",
      transform: "translateY(".concat(position.offset, "px)")
    }), indicatorProps.style)
  })) : null;
});
var CONTENT_NAME = "NavigationMenuContent";
var NavigationMenuContent = React.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
      contentProps = _objectWithoutProperties(props, _excluded9);

  var context = useNavigationMenuContext(CONTENT_NAME, props.__scopeNavigationMenu);
  var itemContext = useNavigationMenuItemContext(CONTENT_NAME, props.__scopeNavigationMenu);
  var composedRefs = useComposedRefs(itemContext.contentRef, forwardedRef);
  var open = itemContext.value === context.value;

  var commonProps = _objectSpread({
    value: itemContext.value,
    triggerRef: itemContext.triggerRef,
    focusProxyRef: itemContext.focusProxyRef,
    wasEscapeCloseRef: itemContext.wasEscapeCloseRef,
    onContentFocusOutside: itemContext.onContentFocusOutside,
    onRootContentClose: itemContext.onRootContentClose
  }, contentProps);

  return !context.viewport ? /* @__PURE__ */jsx(Presence, {
    present: forceMount || open,
    children: /* @__PURE__ */jsx(NavigationMenuContentImpl, _objectSpread(_objectSpread({
      "data-state": getOpenState(open)
    }, commonProps), {}, {
      ref: composedRefs,
      onPointerEnter: composeEventHandlers(props.onPointerEnter, context.onContentEnter),
      onPointerLeave: composeEventHandlers(props.onPointerLeave, whenMouse(context.onContentLeave)),
      style: _objectSpread({
        // Prevent interaction when animating out
        pointerEvents: !open && context.isRootMenu ? "none" : void 0
      }, commonProps.style)
    }))
  }) : /* @__PURE__ */jsx(ViewportContentMounter, _objectSpread(_objectSpread({
    forceMount: forceMount
  }, commonProps), {}, {
    ref: composedRefs
  }));
});
NavigationMenuContent.displayName = CONTENT_NAME;
var ViewportContentMounter = React.forwardRef(function (props, forwardedRef) {
  var context = useNavigationMenuContext(CONTENT_NAME, props.__scopeNavigationMenu);
  var onViewportContentChange = context.onViewportContentChange,
      onViewportContentRemove = context.onViewportContentRemove;
  useLayoutEffect(function () {
    onViewportContentChange(props.value, _objectSpread({
      ref: forwardedRef
    }, props));
  }, [props, forwardedRef, onViewportContentChange]);
  useLayoutEffect(function () {
    return function () {
      return onViewportContentRemove(props.value);
    };
  }, [props.value, onViewportContentRemove]);
  return null;
});
var ROOT_CONTENT_DISMISS = "navigationMenu.rootContentDismiss";
var NavigationMenuContentImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      value = props.value,
      triggerRef = props.triggerRef,
      focusProxyRef = props.focusProxyRef,
      wasEscapeCloseRef = props.wasEscapeCloseRef,
      onRootContentClose = props.onRootContentClose,
      onContentFocusOutside = props.onContentFocusOutside,
      contentProps = _objectWithoutProperties(props, _excluded10);

  var context = useNavigationMenuContext(CONTENT_NAME, __scopeNavigationMenu);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(ref, forwardedRef);
  var triggerId = makeTriggerId(context.baseId, value);
  var contentId = makeContentId(context.baseId, value);
  var getItems = useCollection(__scopeNavigationMenu);
  var prevMotionAttributeRef = React.useRef(null);
  var onItemDismiss = context.onItemDismiss;
  React.useEffect(function () {
    var content = ref.current;

    if (context.isRootMenu && content) {
      var handleClose = function handleClose() {
        var _triggerRef$current;

        onItemDismiss();
        onRootContentClose();
        if (content.contains(document.activeElement)) (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
      };

      content.addEventListener(ROOT_CONTENT_DISMISS, handleClose);
      return function () {
        return content.removeEventListener(ROOT_CONTENT_DISMISS, handleClose);
      };
    }
  }, [context.isRootMenu, props.value, triggerRef, onItemDismiss, onRootContentClose]);
  var motionAttribute = React.useMemo(function () {
    var items = getItems();
    var values = items.map(function (item) {
      return item.value;
    });
    if (context.dir === "rtl") values.reverse();
    var index = values.indexOf(context.value);
    var prevIndex = values.indexOf(context.previousValue);
    var isSelected = value === context.value;
    var wasSelected = prevIndex === values.indexOf(value);
    if (!isSelected && !wasSelected) return prevMotionAttributeRef.current;

    var attribute = function () {
      if (index !== prevIndex) {
        if (isSelected && prevIndex !== -1) return index > prevIndex ? "from-end" : "from-start";
        if (wasSelected && index !== -1) return index > prevIndex ? "to-start" : "to-end";
      }

      return null;
    }();

    prevMotionAttributeRef.current = attribute;
    return attribute;
  }, [context.previousValue, context.value, context.dir, getItems, value]);
  return /* @__PURE__ */jsx(FocusGroup, {
    asChild: true,
    children: /* @__PURE__ */jsx(DismissableLayer, _objectSpread(_objectSpread({
      id: contentId,
      "aria-labelledby": triggerId,
      "data-motion": motionAttribute,
      "data-orientation": context.orientation
    }, contentProps), {}, {
      ref: composedRefs,
      disableOutsidePointerEvents: false,
      onDismiss: function onDismiss() {
        var _ref$current;

        var rootContentDismissEvent = new Event(ROOT_CONTENT_DISMISS, {
          bubbles: true,
          cancelable: true
        });
        (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.dispatchEvent(rootContentDismissEvent);
      },
      onFocusOutside: composeEventHandlers(props.onFocusOutside, function (event) {
        var _context$rootNavigati;

        onContentFocusOutside();
        var target = event.target;
        if ((_context$rootNavigati = context.rootNavigationMenu) !== null && _context$rootNavigati !== void 0 && _context$rootNavigati.contains(target)) event.preventDefault();
      }),
      onPointerDownOutside: composeEventHandlers(props.onPointerDownOutside, function (event) {
        var _context$viewport;

        var target = event.target;
        var isTrigger = getItems().some(function (item) {
          var _item$ref$current;

          return (_item$ref$current = item.ref.current) === null || _item$ref$current === void 0 ? void 0 : _item$ref$current.contains(target);
        });
        var isRootViewport = context.isRootMenu && ((_context$viewport = context.viewport) === null || _context$viewport === void 0 ? void 0 : _context$viewport.contains(target));
        if (isTrigger || isRootViewport || !context.isRootMenu) event.preventDefault();
      }),
      onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
        var isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
        var isTabKey = event.key === "Tab" && !isMetaKey;

        if (isTabKey) {
          var candidates = getTabbableCandidates(event.currentTarget);
          var focusedElement = document.activeElement;
          var index = candidates.findIndex(function (candidate) {
            return candidate === focusedElement;
          });
          var isMovingBackwards = event.shiftKey;
          var nextCandidates = isMovingBackwards ? candidates.slice(0, index).reverse() : candidates.slice(index + 1, candidates.length);

          if (focusFirst(nextCandidates)) {
            event.preventDefault();
          } else {
            var _focusProxyRef$curren;

            (_focusProxyRef$curren = focusProxyRef.current) === null || _focusProxyRef$curren === void 0 || _focusProxyRef$curren.focus();
          }
        }
      }),
      onEscapeKeyDown: composeEventHandlers(props.onEscapeKeyDown, function (_event) {
        wasEscapeCloseRef.current = true;
      })
    }))
  });
});
var VIEWPORT_NAME = "NavigationMenuViewport";
var NavigationMenuViewport = React.forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
      viewportProps = _objectWithoutProperties(props, _excluded11);

  var context = useNavigationMenuContext(VIEWPORT_NAME, props.__scopeNavigationMenu);
  var open = Boolean(context.value);
  return /* @__PURE__ */jsx(Presence, {
    present: forceMount || open,
    children: /* @__PURE__ */jsx(NavigationMenuViewportImpl, _objectSpread(_objectSpread({}, viewportProps), {}, {
      ref: forwardedRef
    }))
  });
});
NavigationMenuViewport.displayName = VIEWPORT_NAME;
var NavigationMenuViewportImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      children = props.children,
      viewportImplProps = _objectWithoutProperties(props, _excluded12);

  var context = useNavigationMenuContext(VIEWPORT_NAME, __scopeNavigationMenu);
  var composedRefs = useComposedRefs(forwardedRef, context.onViewportChange);
  var viewportContentContext = useViewportContentContext(CONTENT_NAME, props.__scopeNavigationMenu);

  var _React$useState15 = React.useState(null),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      size = _React$useState16[0],
      setSize = _React$useState16[1];

  var _React$useState17 = React.useState(null),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      content = _React$useState18[0],
      setContent = _React$useState18[1];

  var viewportWidth = size ? (size === null || size === void 0 ? void 0 : size.width) + "px" : void 0;
  var viewportHeight = size ? (size === null || size === void 0 ? void 0 : size.height) + "px" : void 0;
  var open = Boolean(context.value);
  var activeContentValue = open ? context.value : context.previousValue;

  var handleSizeChange = function handleSizeChange() {
    if (content) setSize({
      width: content.offsetWidth,
      height: content.offsetHeight
    });
  };

  useResizeObserver(content, handleSizeChange);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    "data-state": getOpenState(open),
    "data-orientation": context.orientation
  }, viewportImplProps), {}, {
    ref: composedRefs,
    style: _objectSpread(_defineProperty(_defineProperty({
      // Prevent interaction when animating out
      pointerEvents: !open && context.isRootMenu ? "none" : void 0
    }, "--radix-navigation-menu-viewport-width", viewportWidth), "--radix-navigation-menu-viewport-height", viewportHeight), viewportImplProps.style),
    onPointerEnter: composeEventHandlers(props.onPointerEnter, context.onContentEnter),
    onPointerLeave: composeEventHandlers(props.onPointerLeave, whenMouse(context.onContentLeave)),
    children: Array.from(viewportContentContext.items).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          value = _ref2[0],
          _ref2$ = _ref2[1],
          ref = _ref2$.ref,
          forceMount = _ref2$.forceMount,
          props2 = _objectWithoutProperties(_ref2$, _excluded13);

      var isActive = activeContentValue === value;
      return /* @__PURE__ */jsx(Presence, {
        present: forceMount || isActive,
        children: /* @__PURE__ */jsx(NavigationMenuContentImpl, _objectSpread(_objectSpread({}, props2), {}, {
          ref: composeRefs(ref, function (node) {
            if (isActive && node) setContent(node);
          })
        }))
      }, value);
    })
  }));
});
var FOCUS_GROUP_NAME = "FocusGroup";
var FocusGroup = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      groupProps = _objectWithoutProperties(props, _excluded14);

  var context = useNavigationMenuContext(FOCUS_GROUP_NAME, __scopeNavigationMenu);
  return /* @__PURE__ */jsx(FocusGroupCollection.Provider, {
    scope: __scopeNavigationMenu,
    children: /* @__PURE__ */jsx(FocusGroupCollection.Slot, {
      scope: __scopeNavigationMenu,
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
        dir: context.dir
      }, groupProps), {}, {
        ref: forwardedRef
      }))
    })
  });
});
var ARROW_KEYS = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"];
var FOCUS_GROUP_ITEM_NAME = "FocusGroupItem";
var FocusGroupItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeNavigationMenu = props.__scopeNavigationMenu,
      groupProps = _objectWithoutProperties(props, _excluded15);

  var getItems = useFocusGroupCollection(__scopeNavigationMenu);
  var context = useNavigationMenuContext(FOCUS_GROUP_ITEM_NAME, __scopeNavigationMenu);
  return /* @__PURE__ */jsx(FocusGroupCollection.ItemSlot, {
    scope: __scopeNavigationMenu,
    children: /* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({}, groupProps), {}, {
      ref: forwardedRef,
      onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
        var isFocusNavigationKey = ["Home", "End"].concat(ARROW_KEYS).includes(event.key);

        if (isFocusNavigationKey) {
          var candidateNodes = getItems().map(function (item) {
            return item.ref.current;
          });
          var prevItemKey = context.dir === "rtl" ? "ArrowRight" : "ArrowLeft";
          var prevKeys = [prevItemKey, "ArrowUp", "End"];
          if (prevKeys.includes(event.key)) candidateNodes.reverse();

          if (ARROW_KEYS.includes(event.key)) {
            var currentIndex = candidateNodes.indexOf(event.currentTarget);
            candidateNodes = candidateNodes.slice(currentIndex + 1);
          }

          setTimeout(function () {
            return focusFirst(candidateNodes);
          });
          event.preventDefault();
        }
      })
    }))
  });
});

function getTabbableCandidates(container) {
  var nodes = [];
  var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(node) {
      var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });

  while (walker.nextNode()) nodes.push(walker.currentNode);

  return nodes;
}

function focusFirst(candidates) {
  var previouslyFocusedElement = document.activeElement;
  return candidates.some(function (candidate) {
    if (candidate === previouslyFocusedElement) return true;
    candidate.focus();
    return document.activeElement !== previouslyFocusedElement;
  });
}

function removeFromTabOrder(candidates) {
  candidates.forEach(function (candidate) {
    candidate.dataset.tabindex = candidate.getAttribute("tabindex") || "";
    candidate.setAttribute("tabindex", "-1");
  });
  return function () {
    candidates.forEach(function (candidate) {
      var prevTabIndex = candidate.dataset.tabindex;
      candidate.setAttribute("tabindex", prevTabIndex);
    });
  };
}

function useResizeObserver(element, onResize) {
  var handleResize = useCallbackRef(onResize);
  useLayoutEffect(function () {
    var rAF = 0;

    if (element) {
      var resizeObserver = new ResizeObserver(function () {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return function () {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }
  }, [element, handleResize]);
}

function getOpenState(open) {
  return open ? "open" : "closed";
}

function makeTriggerId(baseId, value) {
  return "".concat(baseId, "-trigger-").concat(value);
}

function makeContentId(baseId, value) {
  return "".concat(baseId, "-content-").concat(value);
}

function whenMouse(handler) {
  return function (event) {
    return event.pointerType === "mouse" ? handler(event) : void 0;
  };
}

var Root2 = NavigationMenu;
var Sub = NavigationMenuSub;
var List = NavigationMenuList;
var Item = NavigationMenuItem;
var Trigger = NavigationMenuTrigger;
var Link = NavigationMenuLink;
var Indicator = NavigationMenuIndicator;
var Content = NavigationMenuContent;
var Viewport = NavigationMenuViewport;
export { Content, Indicator, Item, Link, List, NavigationMenu, NavigationMenuContent, NavigationMenuIndicator, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuSub, NavigationMenuTrigger, NavigationMenuViewport, Root2 as Root, Sub, Trigger, Viewport, createNavigationMenuScope };